var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScale(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184",
    transform: "translate(-542 -635)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_96",
    "data-name": "Rectangle 96",
    width: 18,
    height: 2,
    transform: "translate(542 635)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_97",
    "data-name": "Rectangle 97",
    width: 18,
    height: 4,
    transform: "translate(542 640)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_98",
    "data-name": "Rectangle 98",
    width: 18,
    height: 6,
    transform: "translate(542 647)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScale);
export default __webpack_public_path__ + "static/media/scale.233ae5a5ab3e468d94ea54d806aef815.svg";
export { ForwardRef as ReactComponent };